/* ============================================================
   Foundry — global.js
   Mobile nav, product gallery, qty steppers, AJAX cart count.
   ============================================================ */
(function () {
  'use strict';

  /* ---- Mobile navigation toggle ---- */
  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-nav-toggle]');
    if (toggle) {
      var nav = document.querySelector('[data-mobile-nav]');
      if (nav) {
        nav.classList.toggle('is-open');
        toggle.setAttribute(
          'aria-expanded',
          nav.classList.contains('is-open') ? 'true' : 'false'
        );
      }
    }
  });

  /* ---- Product gallery thumbnails ---- */
  document.addEventListener('click', function (e) {
    var thumb = e.target.closest('[data-thumb]');
    if (!thumb) return;
    var gallery = thumb.closest('[data-gallery]');
    if (!gallery) return;
    var main = gallery.querySelector('[data-gallery-main] img');
    var src = thumb.getAttribute('data-full');
    if (main && src) {
      main.src = src;
      main.srcset = '';
    }
    gallery.querySelectorAll('[data-thumb]').forEach(function (t) {
      t.classList.remove('is-active');
    });
    thumb.classList.add('is-active');
  });

  /* ---- Quantity steppers ---- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qty-change]');
    if (!btn) return;
    var wrapper = btn.closest('[data-qty]');
    if (!wrapper) return;
    var input = wrapper.querySelector('input');
    if (!input) return;
    var step = parseInt(btn.getAttribute('data-qty-change'), 10);
    var val = parseInt(input.value, 10) || 0;
    var next = Math.max(parseInt(input.min || '1', 10), val + step);
    input.value = next;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---- Update cart count badge in header ---- */
  function refreshCartCount() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
          el.style.display = cart.item_count > 0 ? '' : 'none';
        });
      })
      .catch(function () {});
  }

  /* ---- AJAX add to cart (graceful fallback to normal submit) ---- */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-product-form]');
    if (!form) return;
    if (!window.fetch) return; // fall back to default POST

    e.preventDefault();
    var button = form.querySelector('[type="submit"]');
    var original = button ? button.textContent : '';
    if (button) { button.disabled = true; button.textContent = 'Adding…'; }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: new FormData(form)
    })
      .then(function (r) {
        if (!r.ok) throw new Error('add failed');
        return r.json();
      })
      .then(function () {
        refreshCartCount();
        if (button) {
          button.textContent = 'Added ✓';
          setTimeout(function () {
            button.disabled = false;
            button.textContent = original;
          }, 1400);
        }
      })
      .catch(function () {
        form.removeAttribute('data-product-form');
        form.submit();
      });
  });

  refreshCartCount();
})();

/* ============================================================
   Foundry — quick-order, filters, view toggle (added features)
   ============================================================ */
(function () {
  'use strict';

  function formatMoney(cents, currency) {
    var amount = (cents || 0) / 100;
    try {
      return new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: currency || 'USD'
      }).format(amount);
    } catch (e) {
      return '$' + amount.toFixed(2);
    }
  }

  function refreshCartCount() {
    if (!window.fetch) return;
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
          el.style.display = cart.item_count > 0 ? '' : 'none';
        });
      })
      .catch(function () {});
  }

  function addItems(items) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      if (!r.ok) throw new Error('add failed');
      return r.json();
    });
  }

  /* ---- Recompute line + grand totals in a quick-order panel ---- */
  function recompute(panel) {
    if (!panel) return;
    var currency = panel.getAttribute('data-currency');
    var grand = 0;
    panel.querySelectorAll('.qo-row').forEach(function (row) {
      var input = row.querySelector('[data-qo-input]');
      var priceEl = row.querySelector('[data-unit-price]');
      if (!input || !priceEl) return;
      var price = parseInt(priceEl.getAttribute('data-unit-price'), 10) || 0;
      var qty = parseInt(input.value, 10) || 0;
      if (qty < 0) qty = 0;
      var line = price * qty;
      grand += line;
      var lineEl = row.querySelector('[data-line-total]');
      if (lineEl) lineEl.textContent = formatMoney(line, currency);
    });
    var grandEl = panel.querySelector('[data-qo-grand-total]');
    if (grandEl) grandEl.textContent = formatMoney(grand, currency);
  }

  document.addEventListener('input', function (e) {
    var panel = e.target.closest && e.target.closest('[data-quick-order]');
    if (panel) recompute(panel);
  });
  document.addEventListener('change', function (e) {
    var panel = e.target.closest && e.target.closest('[data-quick-order]');
    if (panel) recompute(panel);
  });

  /* ---- Modal open / close ---- */
  var backdrop = null;
  function getBackdrop() {
    if (!backdrop) {
      backdrop = document.createElement('div');
      backdrop.className = 'qo-backdrop';
      backdrop.addEventListener('click', closeModal);
      document.body.appendChild(backdrop);
    }
    return backdrop;
  }
  var openPanel = null;
  function openModal(modal) {
    if (!modal) return;
    closeModal();
    modal.hidden = false;
    modal.classList.add('is-open');
    getBackdrop().style.display = 'block';
    document.body.classList.add('modal-open');
    openPanel = modal;
    var qo = modal.querySelector('[data-quick-order]');
    if (qo) recompute(qo);
  }
  function closeModal() {
    if (openPanel) {
      openPanel.classList.remove('is-open');
      openPanel.hidden = true;
      openPanel = null;
    }
    if (backdrop) backdrop.style.display = 'none';
    document.body.classList.remove('modal-open');
  }

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-qo-open]');
    if (opener) {
      var card = opener.closest('.card');
      var modal = card && card.querySelector('[data-qo-modal]');
      openModal(modal);
      return;
    }
    if (e.target.closest('[data-qo-close]')) {
      closeModal();
      return;
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeModal();
  });

  /* ---- Direct add (single-variant card) ---- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qo-direct]');
    if (!btn) return;
    var id = btn.getAttribute('data-variant-id');
    if (!id) return;
    var label = btn.textContent;
    btn.disabled = true; btn.textContent = 'Adding…';
    addItems([{ id: id, quantity: 1 }])
      .then(function () {
        refreshCartCount();
        btn.textContent = 'Added \u2713';
        setTimeout(function () { btn.disabled = false; btn.textContent = label; }, 1300);
      })
      .catch(function () { btn.disabled = false; btn.textContent = label; });
  });

  /* ---- Bulk add from a quick-order panel ---- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qo-add]');
    if (!btn) return;
    var panel = btn.closest('[data-quick-order]');
    if (!panel) return;

    var items = [];
    panel.querySelectorAll('[data-qo-input]').forEach(function (input) {
      var qty = parseInt(input.value, 10) || 0;
      if (qty > 0) items.push({ id: input.getAttribute('data-variant-id'), quantity: qty });
    });

    if (!items.length) {
      btn.textContent = 'Choose a quantity';
      setTimeout(function () { btn.textContent = 'Add to cart'; }, 1400);
      return;
    }

    btn.disabled = true; btn.textContent = 'Adding…';
    addItems(items)
      .then(function () {
        refreshCartCount();
        btn.textContent = 'Added \u2713';
        setTimeout(function () {
          btn.disabled = false; btn.textContent = 'Add to cart';
          panel.querySelectorAll('[data-qo-input]').forEach(function (i) { i.value = 0; });
          recompute(panel);
          closeModal();
        }, 1100);
      })
      .catch(function () {
        btn.disabled = false; btn.textContent = 'Try again';
        setTimeout(function () { btn.textContent = 'Add to cart'; }, 1600);
      });
  });

  /* ---- Grid / list view toggle ---- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-view]');
    if (!btn) return;
    var grid = document.querySelector('[data-product-grid]');
    if (!grid) return;
    var mode = btn.getAttribute('data-view');
    grid.classList.toggle('product-grid--list', mode === 'list');
    document.querySelectorAll('[data-view]').forEach(function (b) {
      b.classList.toggle('is-active', b === btn);
    });
  });

  /* ---- Filter form auto-submit ---- */
  document.addEventListener('change', function (e) {
    if (e.target.closest('[data-auto-submit]')) {
      var form = e.target.closest('[data-filter-form]');
      if (form) form.submit();
    }
  });
  document.addEventListener('blur', function (e) {
    if (e.target.matches && e.target.matches('[data-auto-submit-blur]')) {
      var form = e.target.closest('[data-filter-form]');
      if (form) form.submit();
    }
  }, true);
})();

/* ============================================================
   Scope marketing — reveal, parallax, count-up
   ============================================================ */
(function () {
  'use strict';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---- Scroll reveal ---- */
  var revealEls = document.querySelectorAll('.reveal');
  if (revealEls.length) {
    if (reduce || !('IntersectionObserver' in window)) {
      revealEls.forEach(function (el) { el.classList.add('is-visible'); });
    } else {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('is-visible'); io.unobserve(e.target); }
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
      revealEls.forEach(function (el) { io.observe(el); });
    }
  }

  /* ---- Hero parallax ---- */
  var layers = document.querySelectorAll('[data-parallax]');
  if (layers.length && !reduce) {
    var ticking = false;
    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        var y = window.pageYOffset;
        layers.forEach(function (el) {
          var speed = parseFloat(el.getAttribute('data-parallax')) || 0;
          el.style.transform = 'translate3d(0,' + (y * speed) + 'px,0)';
        });
        ticking = false;
      });
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---- Count-up stats ---- */
  var counters = document.querySelectorAll('[data-countup]');
  if (counters.length && !reduce && 'IntersectionObserver' in window) {
    var cio = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        var el = e.target;
        cio.unobserve(el);
        var raw = el.textContent.trim();
        var match = raw.match(/^(\d[\d,]*)(.*)$/);
        if (!match) return;
        var target = parseInt(match[1].replace(/,/g, ''), 10);
        var suffix = match[2] || '';
        var prefix = '';
        var dur = 1100, start = null;
        function tick(ts) {
          if (!start) start = ts;
          var p = Math.min((ts - start) / dur, 1);
          var eased = 1 - Math.pow(1 - p, 3);
          el.textContent = prefix + Math.round(target * eased).toLocaleString() + suffix;
          if (p < 1) window.requestAnimationFrame(tick);
        }
        window.requestAnimationFrame(tick);
      });
    }, { threshold: 0.5 });
    counters.forEach(function (el) { cio.observe(el); });
  }
})();

/* ============================================================
   Product gallery — variant -> image/price sync
   ============================================================ */
(function () {
  'use strict';
  document.addEventListener('change', function (e) {
    var sel = e.target.closest('[data-variant-select]');
    if (!sel) return;
    var opt = sel.options[sel.selectedIndex];
    if (!opt) return;
    var root = sel.closest('.product') || document;
    var mainImg = root.querySelector('[data-gallery-main] img');
    var src = opt.getAttribute('data-image');
    if (mainImg && src) {
      mainImg.src = src;
      mainImg.removeAttribute('srcset');
      // sync active thumbnail
      root.querySelectorAll('[data-thumb]').forEach(function (t) {
        var match = t.getAttribute('data-full') === src;
        t.classList.toggle('is-active', match);
      });
    }
    var priceEl = root.querySelector('[data-product-price]');
    var price = opt.getAttribute('data-price');
    if (priceEl && price) priceEl.textContent = price;
  });
})();

/* ============================================================
   Product thumbnail carousel + image lightbox
   ============================================================ */
(function () {
  'use strict';

  /* Carousel arrows scroll the thumbnail track */
  document.addEventListener('click', function (e) {
    var prev = e.target.closest('[data-car-prev]');
    var next = e.target.closest('[data-car-next]');
    if (!prev && !next) return;
    var car = (prev || next).closest('.product__carousel');
    var track = car && car.querySelector('[data-thumb-track]');
    if (!track) return;
    var delta = Math.max(track.clientWidth * 0.7, 120);
    track.scrollBy({ left: prev ? -delta : delta, behavior: 'smooth' });
  });

  /* Lightbox for zoomable images */
  var box;
  function ensureBox() {
    if (box) return box;
    box = document.createElement('div');
    box.className = 'lightbox';
    box.innerHTML = '<button type="button" class="lightbox__close" aria-label="Close">\u00d7</button><img alt="Zoomed product image">';
    box.addEventListener('click', function (ev) {
      if (ev.target === box || ev.target.closest('.lightbox__close')) closeBox();
    });
    document.body.appendChild(box);
    return box;
  }
  function openBox(src) {
    if (!src) return;
    var b = ensureBox();
    b.querySelector('img').src = src;
    b.classList.add('is-open');
    document.body.classList.add('modal-open');
  }
  function closeBox() {
    if (box) { box.classList.remove('is-open'); document.body.classList.remove('modal-open'); }
  }
  document.addEventListener('click', function (e) {
    var z = e.target.closest('[data-zoom-src]');
    if (z) { openBox(z.getAttribute('data-zoom-src')); return; }
    var main = e.target.closest('[data-zoomable]');
    if (main) { openBox(main.currentSrc || main.src); return; }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeBox(); });
})();
